// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1svSk","notes":"Notes_notes__GGIJz"};